import { render } from "./Overlay.vue?vue&type=template&id=658dc503&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=658dc503&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4139241753/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658dc503"]])

export default __exports__